import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const StyledStack = styled(Stack)`
  align-items: flex-start;
  padding: ${({ theme }) => theme.spacing(1.5, 0, 1, 0)};
`;
